import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { WaitNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

const formatSeconds = (seconds: number): string =>
  Number.isInteger(seconds) ? String(seconds) : seconds.toFixed(1);

export const WaitNodeView = memo(function WaitNodeView({ data }: NodeProps<WaitNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const seconds = typeof data.seconds === 'number' && Number.isFinite(data.seconds)
    ? data.seconds
    : 1;
  const summary = displayLanguage === 'en'
    ? `${formatSeconds(seconds)} s`
    : `${formatSeconds(seconds)}秒`;

  return (
    <CardShell
      kind="wait"
      accent="blue"
      title={getNodeDisplayLabel('wait', displayLanguage)}
      summary={summary}
    >
      <Handle type="target" position={Position.Left} className="!bg-blue-500" />
      <Handle type="source" position={Position.Right} className="!bg-blue-500" />
    </CardShell>
  );
});
